import React, { useEffect, useState } from 'react';
import { MessagesService } from 'Services';
import { useAppContext } from 'Contexts';

export const RegistrationLegalNotices = () => {
  const [legalNotice, setLegalNotice] = useState<string>('');
  const { connectionType } = useAppContext();

  useEffect(() => {
    if (!connectionType) return;
    MessagesService.getLegalNotice(connectionType).then(setLegalNotice);
  }, [connectionType]);

  return (
    <div className="text-xs md:max-w-[980px] text-justify m-auto text-sonic-silver px-4 pb-10">
      <p className="[&>a]:underline" dangerouslySetInnerHTML={{ __html: legalNotice }} />
    </div>
  );
};
